export default __webpack_public_path__ + "static/media/SeoCore.ecbf1962.jpg";